<!--
  ~ /*
  ~  * Copyright(c) 2020 General Electric Company. All rights reserved.
  ~  *
  ~  * The copyright to the computer software herein is the property of
  ~  * General Electric Company. The software may be used and/or copied only
  ~  * with the written permission of General Electric Company or in accordance
  ~  * with the terms and conditions stipulated in the agreement/contract
  ~  * under which the software has been supplied.
  ~  */
  -->

<ng-container *ngIf="radList$ | async as radList">
  <div class="modal__content">
    <div class="modal_description" *ngIf="type === types.COREADER">
      <span class="acc"> Acc # {{acc}}</span>
      <br/>
      {{ 'naw.coreaderdialog.description1' | translate }}
      <br/>
      {{ 'naw.coreaderdialog.description2' | translate }}
    </div>
    <div class="modal_description" *ngIf="type === types.REJECT">
      <span class="acc"> Acc # {{acc}}</span>
      <br/>
      {{ 'naw.rejectdialog.description1' | translate }}
      <br/>
      {{ 'naw.rejectdialog.description2' | translate }}
    </div>
    <div class="modal_description" *ngIf="type === types.DEFAULT_COREADER">
      {{ 'naw.autoadvance.coreaderdialog.description1' | translate }}
      <br/>
      {{ 'naw.autoadvance.coreaderdialog.description2' | translate }}
      <br/>
      {{ 'naw.autoadvance.coreaderdialog.description3' | translate }}
    </div>
    <div class="modal_description" *ngIf="type === types.OVERRIDE_DEFAULT_COREADER">
      <span class="acc"> Acc # {{acc}}</span>
      <br/>
      {{ 'naw.coreaderdialog.warning.default.coreader.has.no.access' | translate }}
      <br/>
      {{ 'naw.coreaderdialog.description2' | translate }}
     </div>
     <div class="modal_description" *ngIf="type === types.COREADER_NO_DEFAULT">
       <span class="acc"> Acc # {{acc}}</span>
       <br/>
       {{ 'naw.coreaderdialog.description2' | translate }}
     </div>
    <wfm-select-panel-new
      [search]="true"
      placeholder="{{ 'label.typetosearch' | translate }}"
      [itemTemplate]="radName"
      [items]="radList"
      labelField="name"
      [(value)]="selected"
    >
    </wfm-select-panel-new>
    <wfm-spinner *ngIf="loading" size="40"></wfm-spinner>
  </div>

  <div class="modal__footer u-mt- u-pt--">
    <span class="modal_footer_buttons">
      <button
        id="coReaderDialogIgnoreButton"
        (click)="close(); $event.stopPropagation()"
        tabindex="1"
        class="button button--tertiary ignore-button"
        [innerHTML]="'label.ignore' | translate"
      ></button>
      <button
        id="coReaderDialogConfirmButton"
        (click)="select(); $event.stopPropagation()"
        tabindex="2"
        class="button button--primary confirm-button"
        [disabled]="!selected"
        [ngClass]="{ disabled: !selected }"
        [innerHTML]="'label.confirm' | translate"
      ></button>
    </span>
  </div>

  <ng-template #radName let-i="index" let-item="item">
    {{ item.name }}
  </ng-template>
</ng-container>
